module.exports = __webpack_public_path__ + "static/img/conversation.3db4b53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/conversation.png
// module id = nxwD
// module chunks = 1